import React from "react";

const PieChartLoader = () => {
  return (
    <div className="shadow-loader">
      <div className="pie-shadow" />
    </div>
  );
};

export default PieChartLoader;
